import { ApiOnboardingType, ApiSimpleOnboarding } from "@incendium/api";
import Loading from "Components/Loading/Loading";
import NewOnboardingDialog from "features/onboarding/components/NewOnboardingDialog";
import OnboardingList from "features/onboarding/components/OnboardingList";
import { useAllOnboarding } from "features/onboarding/hooks/useAllOnboarding";
import {
  createOnboarding,
  deleteOnboarding,
} from "features/onboarding/services/onboardingService";
import useAllProjects from "features/project/hooks/useAllProjects";
import { useNotification } from "Hooks";
import { useConfirmation } from "Hooks/useConfirmation";
import produce from "immer";
import { useCallback, useState } from "react";

function OnboardingPage() {
  const { onboarding, setOnboarding, loading } = useAllOnboarding();
  const [open, setOpen] = useState(false);
  const { showSuccessNotification, showErrorNotification } = useNotification();
  const { allProjects } = useAllProjects();
  const handleDelete = useConfirmation();

  const onNew = useCallback(() => {
    setOpen(true);
  }, []);

  const onDelete = useCallback(
    (item: ApiSimpleOnboarding) => {
      handleDelete({
        title: `Are you sure you want to delete this Onboarding`,
        body: `This action can not be undone`,
        callback: async () => {
          await deleteOnboarding(item.projectId!);

          setOnboarding(
            produce(onboarding, (draft) => {
              const idx = onboarding.findIndex(
                (o) => o.projectId === item.projectId,
              );
              if (idx !== -1) draft.splice(idx, 1);
            }),
          );

          return `Onboarding Deleted`;
        },
      });
    },
    [handleDelete, onboarding, setOnboarding],
  );

  const onSave = useCallback(
    async (o: ApiSimpleOnboarding) => {
      try {
        const res = await createOnboarding(
          o.projectId as number,
          o.onboardingType || ApiOnboardingType.ONBOARDING_TYPE_UNKNOWN,
        );
        setOnboarding((o) =>
          produce(o, (draft) => {
            const idx = draft.findIndex((f) => f.id === res.id);
            if (idx >= 0) {
              draft[idx] = res;
            } else {
              draft.push(res);
            }
          }),
        );

        showSuccessNotification(
          `Onboarding started for project ${o.projectId}`,
        );
      } catch (error) {
        showErrorNotification(`Internal error`);
      }
      setOpen(false);
    },
    [showSuccessNotification, showErrorNotification, setOnboarding],
  );

  if (loading) {
    return <Loading fullHeight />;
  }
  return (
    <div>
      <OnboardingList
        items={onboarding}
        onNew={onNew}
        projects={allProjects}
        onDelete={onDelete}
      />
      <NewOnboardingDialog
        open={open}
        setOpen={setOpen}
        onSave={onSave}
        onboardingItems={onboarding}
      />
    </div>
  );
}

export default OnboardingPage;
